var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2D38AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0122 25.0296C30.8045 26.4018 29.8141 28.1172 28.2296 28.1172H12.1852C10.6006 28.1172 9.61028 26.4018 10.4026 25.0296L18.4248 11.1353C19.2171 9.76306 21.1977 9.76307 21.99 11.1353L30.0122 25.0296ZM19.4676 22.4978C19.3772 22.4979 19.332 22.5468 19.332 22.6446V24.3683C19.332 24.466 19.3772 24.5149 19.4676 24.515H21.2024C21.293 24.515 21.3381 24.4661 21.3381 24.3683V22.6446C21.3381 22.5467 21.293 22.4978 21.2024 22.4978H19.4676ZM19.3159 17.3106C19.2144 17.3106 19.1693 17.3581 19.1802 17.4523L19.4676 21.6988C19.4786 21.7856 19.5247 21.8294 19.6043 21.8294H21.0557C21.1353 21.8294 21.1804 21.7856 21.1914 21.6988L21.4798 17.4523C21.4907 17.3582 21.4454 17.3107 21.3441 17.3106H19.3159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL4);
export default __webpack_public_path__ + "static/media/l4.68c343541a006fbff0df6b9701db6102.svg";
export { ForwardRef as ReactComponent };